import {useParams, useRouteMatch} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../i18n/translations';
import {Box, Card, Typography} from '@mui/material';
import GenericHeader from '../../../../../../../components/generic-header/generic-header';
import {UserSeniorForm} from '../../../../../../../components/user-form/user-senior-form';
import {useOffice} from '../../../../../../../contexts/office/context';
import {ScreenPaths, UserFormType} from '../../../../../../../enums';
import {useAuth} from '../../../../../../../contexts/auth/context';
import {RolePermissionType} from '../../../../../../../backend/enums/role-permission-type';
import './senior-profile.professional-caregiver.screen.scss';

export default function SeniorProfileProfessionalCaregiverOfficeScreen() {
  // Get params
  let {id, entityId}: {id?: string; entityId?: string} = useParams();

  if (id?.toLowerCase() === 'create') {
    id = undefined;
  }

  const {t} = useTranslation();
  const officeContext = useOffice();
  const {hasReadPermission, hasWritePermission} = useAuth();

  const userFormType = (() => {
    const writePermission = hasWritePermission(RolePermissionType.Seniors_PersonalData_Profile);
    const readPermission = hasReadPermission(RolePermissionType.Seniors_PersonalData_Profile);

    if (writePermission) return UserFormType.CreateEditRemoveSenior_ProfessionalCaregiver;
    if (readPermission)
      return UserFormType.ReadOnlyCaregiver_ProfessionalCaregiverManagerAndOperator;
    return undefined;
  })();

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  const redirectUrl = `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}`;

  const seniorName =
    officeContext.state.userForm?.user.displayName || officeContext.state.userForm?.user.name;

  // In the future, the "userFormType" may change according to the user permissions.
  // For now, all professional caregivers has the non restricted mode.
  return (
    <Box className="senior-profile-wrapper">
      <GenericHeader
        titleCrumbs={[
          {
            label: t(translations.screen_paths.professional_caregiver_seniors),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
          },
          {
            label: seniorName,
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
          },
          {
            label: t(translations.screen_paths.senior_personal_data),
            link: url,
          },
          {
            label: t(translations.screen_paths.senior_profile),
            link: url,
          },
        ]}
        isLoading={officeContext.state.userFormLoadingState}
        leftColumn={
          <Typography className="senior-profile-header-title" noWrap>
            {t(
              translations.office.professional_caregiver.seniors.edit.profile.generic_header
                .subtitle.write
            )}
          </Typography>
        }
      />
      <Card className="senior-profile-card" elevation={0}>
        {userFormType && (
          <UserSeniorForm
            userFormType={userFormType}
            redirectUrl={redirectUrl}
            entityId={entityId}
          />
        )}
      </Card>
    </Box>
  );
}
